'use strict';

Array.prototype.forEach.call(document.querySelectorAll('.ad a'), function (el) {
    el.addEventListener('click', function () {
        var id = el.dataset.trackingId;
        var device = el.dataset.deviceType;
        dataLayer.push({
            'event_type': 'banner_ad',
            'event_action': 'click',
            'event_category': 'page_ad',
            'event_tenant': 'amcar.no',
            'event_origin': window.location.href,
            'event_device': device,
            'event_label': id
        });
    });
});